define(["require", "exports", "preact/jsx-runtime", "@os/os-components/lib/OsFooter/OsFooter", "preact/hooks", "../utils/analytics", "footer.scss", "ojs/ojknockout"], function (require, exports, jsx_runtime_1, OsFooter_1, hooks_1, analytics_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Footer = void 0;
    const Footer = ({ environment }) => {
        const [trustArcLoaded, setTrustArcLoaded] = (0, hooks_1.useState)(false);
        (0, hooks_1.useEffect)(() => {
            if ((environment === null || environment === void 0 ? void 0 : environment.name) && trustArcLoaded) {
                (0, analytics_1.initAnalytics)(!window.location.href.includes("localhost"), (environment === null || environment === void 0 ? void 0 : environment.name) === "ph" ? "partners" : "osp");
            }
        }, [environment === null || environment === void 0 ? void 0 : environment.name, trustArcLoaded]);
        const oracleLinksOverride = (0, hooks_1.useMemo)(() => (environment === null || environment === void 0 ? void 0 : environment.name) === "ph"
            ? [
                { href: "https://www.oracle.com/corporate/", title: "© Oracle" },
                { href: "https://www.oracle.com/us/syndication/subscribe/", title: "Subscribe" },
                { href: "/partnerhelp/ask/", title: "Contact Us" },
                { href: "https://www.oracle.com/us/legal/terms/", title: "Terms of Use" },
                { href: "https://www.oracle.com/us/legal/privacy/overview/", title: "Privacy" }
            ]
            : undefined, [environment === null || environment === void 0 ? void 0 : environment.name]);
        const socialLinksOverride = (0, hooks_1.useMemo)(() => (environment === null || environment === void 0 ? void 0 : environment.name) === "ph"
            ? [
                { href: "https://www.facebook.com/oraclepartners", title: "Oracle Partners on Facebook", iconClass: "oj-ux-ico-facebook" },
                { href: " https://www.linkedin.com/groups?gid=1935017", title: "Oracle Partners on LinkedIn", iconClass: "oj-ux-ico-linkedin" },
                { href: "https://x.com/oraclepartners", title: "Follow Oracle Partners on X", iconClass: "oj-ux-ico-twitter-x" }
            ]
            : undefined, [environment === null || environment === void 0 ? void 0 : environment.name]);
        return ((0, jsx_runtime_1.jsx)(OsFooter_1.OsFooter, { onTrustArcLoaded: () => setTrustArcLoaded(true), oracleLinks: oracleLinksOverride, socialLinks: socialLinksOverride }));
    };
    exports.Footer = Footer;
});
